<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form ref="edit_role" @submit.prevent="handleSubmit(updateRole)">
      <md-card>
        <md-card-header class="md-card-header-icon">
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
            Edit Role
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Role Name</span
              ><span style="color:red">*</span>
            </label>
            <div class="md-layout-item">
              <validation-provider rules="name" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <md-input v-model="role_name" />
                  <validation-error :errors="apiValidationErrors.role_name" />
                </md-field>
                <span>{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Division</span><span style="color:red">*</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="division" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-select v-model="division_id">
                <md-option v-for="option in options_divisions" :key="option.value" :value="option.id">
                  {{ option.division_name }}
                </md-option>
              </md-select>
              <validation-error :errors="apiValidationErrors.division_id" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div>
        </md-card-content>
        <md-card-actions>
          <md-button @click="editConfirmation">
            Edit Role Name
          </md-button>
          <md-button class="md-info" @click="backtoList">
            Go to List
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend, validate, localize, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";

Vue.use(VueSweetalert2);

extend("name", {
  ...required,
  message: "Name field is required",
});
extend("division", {
  ...required,
  message: "Division field is required",
});
export default {
  name: "edit-role",

  components: { ValidationError, ValidationObserver },
  mixins: [formMixin],

  data: () => ({
    division_id: null,
    role_name: null,
    options_divisions: null,
  }),

  created() {
    this.onOpen();
  },

  methods: {
    
    // fungsi tombol direct ke list role
    backtoList() {
      this.$router.replace({ name: "List Role" });
    },

    // ambil data yang dibutuhkan
    async onOpen() {
      // check data dengan id di route
      if (this.$route.params.id) {
        console.log(this.$route.params.id);
        await this.$store.dispatch("role/get", this.$route.params.id);
        this.role = await this.$store.getters["role/role"];
        this.role_name = this.role.name;
        this.division_id = this.role.division_id;
        await this.$store.dispatch("division/list")
        this.options_divisions = await this.$store.getters["division/list"]
        console.log(this.role);
      }
    },

    // validasi edit data
    editConfirmation(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be edited!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Edit it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.updateRole();
        }
      });
    },

    // fungsi edit data
    async updateRole() {
      if (this.$route.params.id == null || !this.$route.params.id) {
       this.backtoList()
      }

      const data = {
        type: "roles",
        id: this.role.id,
        name: this.role_name,
        division_id: this.division_id,
      };

      try {
        // kirim data ke api
        await this.$store.dispatch("role/update", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Vehicle Brand data changed successfully."
        );
        await this.$router.replace({ name: "List Role" });
        //this.$refs['password_form'].reset()
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong!"
        );
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
